<template>
  <div class='etcMask' :class="{'opacity1':showFlag, 'maskfalse':!mask}" @click='closeFlag'>
    <div class='wrap' :class="{'wrapshow':showFlag}" @click.stop='rf'>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  props: {
    showFlag: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeFlag () {
      this.mask && this.$emit('onShowpop', false)
    },
    rf () {
      return false
    }
  }
}
</script>

<style scoped>
.etcMask{
  position:fixed;
  z-index: 1;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.4);
  top:0;
  left:0;
  opacity: 0;
  transition: all 0.3s linear;
  -webkit-transition: all 0.2s linear;
  pointer-events: none;
}
.maskfalse{
  pointer-events: none!important;
  background-color:rgba(0,0,0,0);
}
.opacity1{
  opacity: 1;
  pointer-events: initial;
  transition: all 0.1s linear;
  -webkit-transition: all 0.1s linear;
}
.wrap{
  pointer-events: initial;
  width:100%;
  position:absolute;
  bottom:0;
  left:0;
  transform: translateY(100%);
  -webkit-transform: translateY(100%);
  transition: all 0.1s linear;
  -webkit-transition: all 0.1s linear;
}
.wrapshow{
  transform: translateY(0);
  -webkit-transform: translateY(0);
}
</style>
